import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  section: {
    border: `1px solid ${theme.new.color.line.hairline}`,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.new.spacing.medium,
  },
  header: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.new.spacing.medium,
  },
}));

export default useStyles;
